import monogramUrl from "./assets/monogramme-opulancia.png?url";
import type { LoadedImage } from "./render.js";

/** The OPULANCIA monogram drawn on the last slide (Signature v0.2 § 7), or null when it cannot be loaded. */
export async function loadMonogram(): Promise<LoadedImage | null> {
  try {
    const bitmap = await createImageBitmap(await (await fetch(monogramUrl)).blob());
    return { source: bitmap, width: bitmap.width, height: bitmap.height };
  } catch {
    return null;
  }
}
